<template>
      <div class="ready-to-launch">
        <h2>Ready to Launch?</h2>
        <div class="row">
          <div class="col-md-8">
            <div class="campaign-overview">
              <h3>Campaign Overview</h3>
              <div class="campaign-overview-list">
                <div class="row">
                  <div class="col-md-10 offset-md-1">
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Campaign Name</h4>
                        <h6>{{ getCampaignDetail.campaign_name }}</h6>
                        <h4>Num of Activities</h4>
                        <h6>{{ getCampaignDetail.total_activity_count }}</h6>
                        <h4>Budget</h4>
                        <h6>{{ getCampaignDetail.campaign_budget }}</h6>
                        <h4>Incentive Type</h4>
                        <h6>{{ getCampaignDetail.incentive_type }}</h6>
                        <h4>Start-Date - <span>{{ getCampaignDetail.start_date }}</span></h4>
                        <h4>End-Date - <span>{{ getCampaignDetail.end_date }}</span></h4>
                        <h4>Unlock Code</h4>
                        <h6>{{ getCampaignDetail.unlock_code }}</h6>

                      </div>
                      <div class="col-md-6">
                        <h4>Geo-Location Type</h4>
                        <h6>{{ getCampaignDetail.geo_location_type }}</h6>
                        <h4>Single User Limit</h4>
                        <h6>{{ getCampaignDetail.single_user_limit }}</h6>
                        <h4>Incentives</h4>
                        <h6>{{ getCampaignDetail.coupon }}</h6>
                        <h4>Package of Benefit</h4>
                        <h6>{{ getCampaignDetail.package }}</h6>
                        <h4>Buy Me Activity</h4>
                        <h6>Not available for freemium</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
          <div class="preview" v-if="getCampaignDetail.geo_location_type == 'any-physical-location'">
          <div class="brand_head">
            <img src="/img/Arrow_2.png" />
            {{ getStoreDetail.brandName }}<br />{{ getStoreDetail.name }}
          </div>
         <h6></h6>
          <div class="store_brand">
            <img :src="getStoreDetail.img" class="left_brand" />
            <h6>Do it at any location</h6>
            <img :src="getStoreDetail.brandImg" class="right_brand" />
          </div>
          <div class="brand_intro">
            <div class="brand_desc">
              <div class="brand_header">
                <img :src="getProductDetail.img" />
                <h6 style="text-align: left;">{{ getProductDetail.name }}</h6>
                <p class="special_notes">Special Notes</p>
              </div>
              <ul style="max-height: 130px; overflow: hidden; padding-left: 0; margin-top: 15px;">
                <li v-for="task in getTasks" :key="task.name">{{ task.name }}</li>
              </ul>
              <img src="/img/start_pickl.png" class="start_pickl" />
            </div>
          </div>
          <img src="/img/phone_bottom.png" class="task_bar" />
        </div>
        <div class="preview cr_page" v-else>
            <div class="brand_head">
              <img src="/img/Arrow_2.png" />
              {{ getStoreDetail.brandName }}
            </div>
            <div class="media_name">
              {{ media.title }}
            </div>
            <div class="your_video">
              <span
                ><iframe
                  width="100%"
                  height="120px"
                  :src="'https://www.youtube.com/embed/'+videoId"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe></span>
            </div>
            <div class="brand_intro" style="top: 266px !important">
              <div class="brand_desc">
                <div class="brand_header">
                  <img :src="brandInfo.logo" />
                  <h6>{{ brandInfo.name }}</h6>
                  <p>Introduction</p>
                </div>
                <p style="font-size: 13px; padding: 12px; text-align: left;">
                  {{ media.description }}
                </p>
              </div>
            </div>
            <img src="/img/phone_bottom.png" class="task_bar" />
          </div>
          </div>
        </div>

      </div>
</template>
<script>
export default {
  name: 'AadvancedReview',
  data () {
    return {
      getStoreDetail: {},
      getProductDetail: {},
      getCampaignDetail: {},
      media: {},
      videoId: '',
      getTasks: [],
      brandInfo: {
        name: '',
        logo: ''
      }
    }
  },
  mounted () {
    this.getStoreDetails()
    this.getProductTaskDetails()
    this.getCampaignView()
    this.getMedia()
  },
  methods: {
    getStoreDetails () {
      this.loadingStaff = true
      this.$http.get('plg/campaign-setting-store-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getStoreDetail = response.data
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getCampaignView () {
      this.$http.get('plg/get-campaign-reviewer-details/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getCampaignDetail = response.data
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getMedia () {
      this.$http.get('plg/campaign-media-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.media = response.data
          this.videoId = this.extractVideoId(this.media.video_url)
          console.log(this.videoId)
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    extractVideoId (url) {
      const regex = /(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/
      const match = url.match(regex)
      return match ? match[1] : null
    },
    getProductTaskDetails () {
      this.$http.get('plg/campaign-product-task-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getProductDetail = response.data.productDetails
          this.getTasks = response.data.tasks
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    }
  }

}
</script>
<style>
.ready-to-launch h2 {
    text-align: center;
    color: #782B55;
    margin-top: 35px;
    margin-bottom: 30px;
    font-weight: 700;
}
.ready-to-launch p{
    text-align: center;
    font-size: 17px;
    margin-bottom: 30px;
}
.campaign-overview {
    background: #F9F9F9;
    border: 1px solid #000;
    padding: 15px 30px;
    border-radius: 8px;
}
.campaign-overview h3{
    color: #000;
    font-size: 24px;
}
.ready-to-launch .preview{
    background: url("/../img/Home_Screen_Widgets.png");
    background-size: 100%;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 620px;
    max-width: 300px;
    margin: 0 auto;
    position: relative;
}
.ready-to-launch .brand_head {
    text-align: center;
    margin-top: 50px;
    position: absolute;
    width: 82%;
    margin-left: 9%;
    padding: 7px;
    color: #000;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
}
.ready-to-launch .brand_head img {
    position: absolute;
    left: 12px;
    top: 19px;
    width: 8px;
}
.ready-to-launch .store_brand {
    position: absolute;
    width: 82%;
    left: 9%;
    top: 98px;
    border-top: 1px solid #DEF2E6;
    padding-top: 3px;
}
.ready-to-launch .brand_intro {
    height: 280px;
    background: #FBF0E8;
    width: 82%;
    position: absolute;
    left: 9%;
    top: 145px;
}
.ready-to-launch .brand_header {
    border-bottom: 1px solid #12DA6D;
    width: 90%;
    margin-left: 5%;
    padding: 5px 5px;
}
.ready-to-launch .brand_header img {
    width: 52px;
    float: left;
    margin-right: 5px;
}
.ready-to-launch .brand_header h6 {
    font-family: "Roboto", sans-serif;
    color: #782B55;
    font-size: 14px;
    margin-left: 5px;
    margin-top: 3px;
    margin-bottom: 5px;
}
.ready-to-launch .brand_header p {
    font-size: 12px;
    margin-left: 0px;
    display: inline;
    background: #F1605C;
    color: #fff;
    padding: 5px 8px;
    border-radius: 20px;
}
.ready-to-launch .task_bar {
    width: 82%;
    position: absolute;
    bottom: 40px;
    left: 9%;
}
.ready-to-launch .start_pickl {
    position: absolute;
    bottom: 20px;
    margin: 0 auto;
    left: 0;
    right: 0;
    max-width: 100%;
}
.ready-to-launch .store_brand h6 {
    text-align: center;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    line-height: 23px;
    margin-top: -20px;
}
.ready-to-launch .right_brand {
    position: absolute;
    right: 0px;
    width: 35px;
    max-height: 40px;
    top: 3px;
}
.ready-to-launch .brand_intro ul li {
    color: #631C3C;
    font-size: 13px;
    margin-bottom: 15px;
    padding-left: 30px;
    position: relative;
    line-height: 16px;
}
.ready-to-launch .brand_desc li:after{
    content: "";
    position: absolute;
    z-index: 1;
    left: 5px;
    width: 20px;
    height: 20px;
    background: url("/../img/check.png");
    background-size: 100%;
}
.campaign-overview-list h4{
    color: #000;
    font-size: 19px;
    font-family: "Roboto", sans-serif;
    margin-top: 20px;
    margin-bottom: 5px;
}
.campaign-overview-list h6{
    color: #000;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    margin-bottom: 30px;
}
.campaign-overview-list h4 span{
    font-size: 16px;
    font-weight: 400;
}
.ready-to-launch {
    margin-bottom: 30px;
}
.brand_head {
    text-align: center;
    margin-top: 65px;
    position: absolute;
    width: 82%;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
    margin-left: 9%;
    padding: 7px;
    color: #000;
    font-size: 15px;
}
.media_name {
    background: #FBF0E8;
    text-align: center;
    width: 82%;
    position: absolute;
    left: 9%;
    top: 105px;
    padding: 8px;
    color: #782B55;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
}
.your_video {
    background: #E7E2DF;
    text-align: center;
    text-transform: uppercase;
    width: 82%;
    left: 9%;
    position: absolute;
    top: 145px;
}
.brand_header {
    border-bottom: 1px solid #12DA6D;
    width: 90%;
    margin-left: 5%;
    padding: 5px 5px;
}
.brand_desc {
    width: 90%;
    height: 260px;
    background: #fff;
    margin-left: 5%;
    margin-top: 10px;
    border: 1px solid #12DA6D;
    border-radius: 6px;
}
/* .brand_intro {
    height: 280px;
    background: #FBF0E8;
    width: 82%;
    position: absolute;
    left: 9%;
    top: 266px !important;
} */

</style>
